webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(108)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(138),
  /* scopeId */
  "data-v-50e2753c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var throttle = function throttle(fun, maxTime) {
  var timer = void 0;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(fun, maxTime);
  };
};

var mapStringToHanzi = function mapStringToHanzi(string) {
  var mapObj = {
    'all': '全部',
    'good': '精华',
    'share': '分享',
    'job': '工作',
    'ask': '问答'
  };
  return mapObj[string];
};

var showOrHideScroll = function showOrHideScroll(top) {
  var defaulTop = top || 500;
  var scrollTop = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
  if (scrollTop > defaulTop) this.$backToTop().show();else this.$backToTop().hide();
};
/* harmony default export */ __webpack_exports__["a"] = ({
  throttle: throttle,
  mapStringToHanzi: mapStringToHanzi,
  showOrHideScroll: showOrHideScroll
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(111)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(141),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install() {
    var timer = null;
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$alerTips = function (msg, options) {
      var option = options || '';
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tip').remove();

      var $div = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class='tip' id='tip'></div>");
      if (option) {
        $div.css(option);
      }
      $div.text(msg);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').append($div);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tip').addClass('showAlert');
      clearTimeout(timer);
      timer = setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tip').remove();
        timer = null;
      }, 2000);
    };
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$backToTop = function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#backToTop').remove();
      var $div = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("<div id='backToTop' class='backToTop'></div>");
      $div.on('click', function () {
        return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).scrollTop(0);
      });
      var $i = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("<i class='cnode-iconfont back'>&#xe630;</i>");
      $div.append($i);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').append($div);
      function show() {
        $div.css({ 'visibility': 'visible' });
      }
      function hide() {
        $div.css({ 'visibility': 'hidden' });
      }
      return {
        show: show,
        hide: hide
      };
    };
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Welcome__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Post__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Message__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Login__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Me__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Me___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Me__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Topic__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Topic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Topic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_About__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_About__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: 'v-cnode',
  linkActiveClass: 'cnode-active',
  routes: [{
    path: '/',
    name: 'Welcome',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Welcome___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Login___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_About___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Home___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/post',
    name: 'Post',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_Post___default.a,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/message',
    name: 'Message',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Message___default.a,
    meta: {
      requireAuth: true
    }
  }, {
    path: '/me',
    name: 'Me',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Me___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/topic/:id',
    name: 'Topic',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Topic___default.a,
    meta: {
      requireAuth: false
    }
  }, {
    path: '*',
    redirect: '/home'
  }]
}));

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);




__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    userInfo: {
      loginname: '',
      avatar_url: '',
      userId: '',
      token: ''
    }
  },
  getters: {
    getUserInfo: function getUserInfo(state) {
      return state.userInfo;
    }
  },
  mutations: {
    setUserInfo: function setUserInfo(state, user) {
      state.userInfo = user;
    }
  },
  actions: {
    setUserInfo: function setUserInfo(_ref, user) {
      var commit = _ref.commit;

      window.window.sessionStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user);
      commit('setUserInfo', user);
    }
  }
}));

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(116)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'comment_list',
    props: {
        comment: {
            type: Object,
            default: {}
        }
    },
    data: function data() {
        return {};
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
        userInfo: 'getUserInfo'
    })),
    methods: {
        doGood: function doGood() {
            alert('正在开发。。');
        }
    },
    components: {}
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'footer',
    props: {},
    data: function data() {
        return {};
    },

    methods: {},
    components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  props: {
    showMenuButton: {
      type: Boolean,
      default: true
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    showPostButton: {
      type: Boolean,
      default: true
    },
    handleMenuButton: {
      type: Function,
      default: function _default() {
        return;
      }
    },
    handlePostButton: {
      type: Function,
      default: function _default() {
        return;
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '全部'
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    showMenu: function showMenu() {
      this.handleMenuButton(!this.show);
    },
    handleBackButton: function handleBackButton() {
      this.$router.back();
    },
    goPost: function goPost() {
      this.$router.push({
        path: '/post'
      });
    }
  },
  mounted: function mounted() {},

  components: {}
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'list_item',
    props: {
        item: {
            type: Object
        }
    },
    data: function data() {
        return {};
    },

    methods: {},
    components: {}
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loading',
    props: {},
    data: function data() {
        return {};
    },

    methods: {},
    components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_list_item_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_list_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_list_item_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'list',
    props: {
        array: Array
    },
    data: function data() {
        return {
            showLoading: true
        };
    },

    methods: {},
    beforeMount: function beforeMount() {},
    mounted: function mounted() {},

    components: {
        vListItem: __WEBPACK_IMPORTED_MODULE_0__common_list_item_vue___default.a
    }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  props: {
    showSideBar: Boolean,
    toggleSideBar: Function
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    userInfo: 'getUserInfo'
  })),
  data: function data() {
    return {
      user: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.userInfo, this.getUserFromSession())
    };
  },

  methods: {
    hide: function hide() {
      this.toggleSideBar(!this.showSideBar);
    },
    getUserFromSession: function getUserFromSession() {
      var user = window.window.sessionStorage.user;
      return user && JSON.parse(user);
    }
  },
  components: {}
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_header__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_common_header__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'about',
    props: {},
    data: function data() {
        return {
            show: false,
            title: '关于'
        };
    },

    methods: {},
    components: {
        vHeader: __WEBPACK_IMPORTED_MODULE_0__components_common_header___default.a
    }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_header__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_footer__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_list_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sidebar_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sidebar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_loading_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_js_utils_js__ = __webpack_require__(19);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  data: function data() {
    return {
      show: false,
      title: '全部',
      listArray: [],
      showLoading: true,
      currentPage: 1
    };
  },

  methods: {
    showOrHideMask: function showOrHideMask(show) {
      this.show = show;
    },
    hide: function hide() {
      this.show = !this.show;
    },
    updateHeaderTitle: function updateHeaderTitle(title) {
      this.title = title;
    },
    loadMore: function loadMore() {
      var _this = this;

      var scrollTop = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).scrollTop();
      var windowHeight = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).height();
      var documentHeight = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(document).height();
      if (scrollTop + windowHeight > documentHeight - 2000) {
        var page = ++this.currentPage;
        var tab = this.$route.query.type || 'all';
        console.log(page, tab);
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://cnodejs.org/api/v1/topics?' + 'page=' + page + '&tab=' + tab).then(function (arr) {
          return _this.listArray = _this.listArray.concat(arr.data.data);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var array = window.window.sessionStorage.array;
    if (array) {
      array = JSON.parse(array);
      this.listArray = array;
      this.showLoading = false;
      this.$nextTick(function () {
        return __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).scrollTop(window.window.sessionStorage.scrollTop);
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://cnodejs.org/api/v1/topics').then(function (arr) {
        _this2.listArray = arr.data.data;
        _this2.showLoading = !_this2.showLoading;
      }).catch(function (error) {
        return _this2.$alerTips('出错了！');
      });
    }
    __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).on('scroll', __WEBPACK_IMPORTED_MODULE_8__assets_js_utils_js__["a" /* default */].throttle(__WEBPACK_IMPORTED_MODULE_8__assets_js_utils_js__["a" /* default */].showOrHideScroll.bind(this), 500));
    __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).on('scroll', __WEBPACK_IMPORTED_MODULE_8__assets_js_utils_js__["a" /* default */].throttle(this.loadMore, 2000));
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name === 'Topic') {
      var scrollTop = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).scrollTop();
      var array = this.listArray;
      window.window.sessionStorage.scrollTop = scrollTop;
      window.window.sessionStorage.array = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(array);
      this.$backToTop().hide();
      __WEBPACK_IMPORTED_MODULE_6_jquery___default()(window).off('scroll');
    }
    next();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name !== 'Topic') {
      window.window.sessionStorage.removeItem('array');
    }
    next();
  },

  watch: {
    '$route': function $route(to, from) {
      var _this3 = this;

      console.log('list页面路由监听');
      if (to.query && to.query.type) {
        console.log('success');
        var tab = to.query.type;
        this.title = __WEBPACK_IMPORTED_MODULE_8__assets_js_utils_js__["a" /* default */].mapStringToHanzi(tab);
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://cnodejs.org/api/v1/topics?tab=' + tab + '&page=1').then(function (arr) {
          _this3.listArray = arr.data.data;
        }).catch(function (err) {
          return _this3.$alerTips(err);
        });
      }
    }
  },
  components: {
    vHeader: __WEBPACK_IMPORTED_MODULE_1__components_common_header___default.a,
    vList: __WEBPACK_IMPORTED_MODULE_3__components_list_vue___default.a,
    vSideBar: __WEBPACK_IMPORTED_MODULE_4__components_sidebar_vue___default.a,
    vLoading: __WEBPACK_IMPORTED_MODULE_5__components_common_loading_vue___default.a,
    vFooter: __WEBPACK_IMPORTED_MODULE_2__components_common_footer___default.a
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_header__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  props: {},
  data: function data() {
    return {
      show: false,
      title: '登录',
      accesstoken: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapActions */])({
    setUserInfo: 'setUserInfo'
  }), {
    handleLogin: function handleLogin() {
      var _this = this;

      if (!this.accesstoken) {
        this.$alerTips('AccessToken不能为空！');
      } else {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://cnodejs.org/api/v1/accesstoken', {
          accesstoken: this.accesstoken
        }).then(function (data) {
          var user = {
            loginname: data.data.loginname,
            avatar_url: data.data.avatar_url,
            userId: data.data.id,
            token: _this.accesstoken
          };
          _this.setUserInfo(user);
          _this.$alerTips('登陆成功！', { 'background-color': '#03A9F4' });
          setTimeout(function () {
            return _this.$router.go(-1);
          }, 1950);
        }).catch(function (error) {
          return _this.$alerTips('Token格式有误！');
        });
      }
    }
  }),
  components: {
    vHeader: __WEBPACK_IMPORTED_MODULE_1__components_common_header___default.a
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_header__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'me',
  data: function data() {
    return {
      show: false,
      title: '我的',
      user: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.userInfo, this.getUserFromSession())
    };
  },

  methods: {
    getUserFromSession: function getUserFromSession() {
      var user = window.window.sessionStorage.user;
      return user && JSON.parse(user);
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    userInfo: 'getUserInfo'
  }),
  mounted: function mounted() {
    var _this = this;

    var loginname = this.userInfo.loginname;
    if (loginname) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://cnodejs.org/api/v1/user/' + loginname).then(function (userDetail) {
        _this.user = userDetail.data.data;
        console.log(_this.user);
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },

  components: {
    vHeader: __WEBPACK_IMPORTED_MODULE_1__components_common_header___default.a
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_header__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'message',
  data: function data() {
    return {
      show: false,
      title: '消息',
      active: 'done',
      message_count: '',
      has_read_message: [],
      hasnot_read_message: [],
      user: {}
    };
  },

  methods: {
    toggle: function toggle(msg) {
      this.active = msg;
    },
    getUserFromSession: function getUserFromSession() {
      var userFromSession = window.window.sessionStorage.user;

      if (userFromSession) userFromSession = JSON.parse(userFromSession);else userFromSession = {};
      return userFromSession;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    userInfo: 'getUserInfo'
  })),
  mounted: function mounted() {
    var _this = this;

    var userFromSession = this.getUserFromSession();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.user, this.userInfo, userFromSession);

    var token = this.user.token;
    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://cnodejs.org/api/v1/messages?accesstoken=' + token + '&mdrender=true').then(function (result) {
      _this.has_read_message = result.data.data.has_read_messages;
      _this.hasnot_read_message = result.data.data.hasnot_read_messages;
      _this.message_count = _this.hasnot_read_message.length;
    }).catch(function (err) {
      return console.log(err);
    });
  },

  components: {
    vHeader: __WEBPACK_IMPORTED_MODULE_2__components_common_header___default.a
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_header__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_common_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(4);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post',
  data: function data() {
    return {
      show: false,
      title: '发表',
      article: {
        title: '',
        tab: '',
        content: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    user: 'getUserInfo'
  })),
  methods: {
    handleSubmit: function handleSubmit() {
      var _this = this;

      var article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.article, {
        accesstoken: this.user.token
      });
      debugger;
      if (article.title.length < 11) {
        this.$alerTips('标题字数没超过十个字！');
        return;
      }
      if (article.tab == '') {
        this.$alerTips('请选择文章类型！');
        return;
      }
      if (article.content == '') {
        this.$alerTips('文章内容不能为空！');
        return;
      }
      if (article.accesstoken) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://cnodejs.org/api/v1/topics', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, article)).then(function () {
          debugger;
          _this.$alerTips('发表成功啦！');
          _this.$router.push({
            path: '/home'
          }, 1990);
        }).catch(function (err) {
          return alert(err);
        });
      }
    }
  },
  mounted: function mounted() {},

  components: {
    vHeader: __WEBPACK_IMPORTED_MODULE_1__components_common_header___default.a
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_header_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_comment_item_vue__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_comment_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_comment_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_utils_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'detail',
  props: {},
  data: function data() {
    return {
      article: null,
      title: '主题',
      showLoading: true,
      go_comment: ''
    };
  },

  methods: {
    handleComment: function handleComment() {
      var _this = this;

      var comment = {
        accesstoken: this.userInfo.token,
        content: this.go_comment,
        reply_id: ''
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://cnodejs.org/api/v1/topic/' + this.article.id + '/replies', comment).then(function (result) {
        alert('评论成功！');
        _this.go_comment = '';
        console.log(result.data.reply_id);
      });
    },
    cancleComment: function cancleComment() {
      this.go_comment = '';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])({
    userInfo: 'getUserInfo'
  })),
  components: {
    vHeader: __WEBPACK_IMPORTED_MODULE_2__components_common_header_vue___default.a,
    vLoading: __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue___default.a,
    vCommentItem: __WEBPACK_IMPORTED_MODULE_4__components_common_comment_item_vue___default.a
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$route.params.id) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://cnodejs.org/api/v1/topic/' + this.$route.params.id).then(function (article) {
        _this2.article = article.data.data;
        _this2.showLoading = !_this2.showLoading;
      });
    }
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(window).on('scroll', __WEBPACK_IMPORTED_MODULE_6__assets_js_utils_js__["a" /* default */].throttle(__WEBPACK_IMPORTED_MODULE_6__assets_js_utils_js__["a" /* default */].showOrHideScroll.bind(this), 500));
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$backToTop().hide();
    __WEBPACK_IMPORTED_MODULE_7_jquery___default()(window).off('scroll');
    next();
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {};
  },

  methods: {
    startAnimate: function startAnimate(title) {
      var _this = this;

      var s = title;
      var con = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hello');
      var index = 0;
      var length = s.length;
      var tId = null;
      con.text('');
      tId = setInterval(function () {
        con.append(s.charAt(index));
        if (index++ === length) {
          clearInterval(tId);
          setTimeout(function () {
            _this.$router.push({
              path: 'home'
            });
          }, 500);
        }
      }, 200);
    }
  },
  mounted: function mounted() {
    this.startAnimate('Cnode-Vue');
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_user_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_alerTips_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_js_backToTop_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lib_flexible_flexible_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lib_flexible_flexible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lib_flexible_flexible_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_reset_css__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_styles_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_styles_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fastclick__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_github_markdown_css__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_github_markdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_github_markdown_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_styles_iconfont_iconfont_css__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_styles_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_styles_iconfont_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_styles_animate_css__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_styles_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_styles_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_styles_common_scss__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_styles_common_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_styles_common_scss__);








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__assets_js_alerTips_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__assets_js_backToTop_js__["a" /* default */]);








__WEBPACK_IMPORTED_MODULE_9_fastclick___default.a.attach(document.body);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  console.log('全局路由控制');
  if (to.matched.some(function (route) {
    return route.meta.requireAuth;
  })) {
    var user = window.window.sessionStorage.user;
    user = user && JSON.parse(user);
    user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__vuex_user_js__["a" /* default */].state.userInfo, user);
    if (user.userId) {
      next();
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_user_js__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(133),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(115)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(113)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(143),
  /* scopeId */
  "data-v-7dceaacf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(112)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(142),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(102)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(132),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(110)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(140),
  /* scopeId */
  "data-v-63136230",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(107)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(137),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(114)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(144),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(105)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(135),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(139),
  /* scopeId */
  "data-v-53beccbc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(117)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(147),
  /* scopeId */
  "data-v-fec500d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(106)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(136),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(104)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(134),
  /* scopeId */
  "data-v-09f20f7d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['vsidebar', {
      show: _vm.showSideBar
    }]
  }, [_c('div', {
    staticClass: "login"
  }, [(_vm.user.loginname) ? _c('router-link', {
    attrs: {
      "to": "/me",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user && _vm.user.avatar_url,
      "alt": "用户头像"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user && _vm.user.loginname))])]) : _c('router-link', {
    attrs: {
      "to": "/login",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(26),
      "alt": "unlogin.jpg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s('点此登录'))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "topics"
  }, [_c('ul', {
    on: {
      "click": _vm.hide
    }
  }, [_c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'all'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("全部")]), _vm._v(" "), _c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'good'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("精华")]), _vm._v(" "), _c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'share'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("分享")]), _vm._v(" "), _c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'ask'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("问答")]), _vm._v(" "), _c('router-link', {
    staticClass: "topic",
    attrs: {
      "to": {
        path: 'home',
        query: {
          type: 'job'
        }
      },
      "tag": "li"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("招聘")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "about"
  }, [_c('router-link', {
    attrs: {
      "to": "/about",
      "tag": "span"
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("关于")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment_list"
  }, [_c('div', {
    staticClass: "comment_top"
  }, [_c('div', {
    staticClass: "c_top_left"
  }, [_c('img', {
    attrs: {
      "src": _vm.comment.author.avatar_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.comment.author.loginname))]), _vm._v("3分钟前\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "c_top_right"
  }, [_c('i', {
    staticClass: "cnode-iconfont",
    on: {
      "click": _vm.doGood
    }
  }, [_vm._v("\n          "), _c('span', [_vm._v(_vm._s(_vm.comment.ups.length))])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "comment_bottom"
  }, [_c('div', {
    staticClass: "commet_detail markdown-body",
    domProps: {
      "innerHTML": _vm._s(_vm.comment.content)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("\n          "), _c('span')])
}]}

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  })
},staticRenderFns: []}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "me"
  }, [_c('v-header', {
    attrs: {
      "show_parent": _vm.show,
      "title": _vm.title,
      "showBackButton": true,
      "showMenuButton": false,
      "showPostButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "me-detail"
  }, [_c('div', {
    staticClass: "me-header"
  }, [(_vm.user.avatar_url) ? _c('img', {
    attrs: {
      "src": _vm.user.avatar_url,
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__(26),
      "alt": "unlogin.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.user.loginname || '暂未登录'))])]), _vm._v(" "), _c('div', {
    staticClass: "me-item item1"
  }, [_c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("发表主题" + _vm._s(_vm.user.recent_topics && _vm.user.recent_topics.length || 0)), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("我的消息" + _vm._s(_vm.user.recent_replies && _vm.user.recent_replies.length || 0)), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])])]), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "me-item item2"
  }, [_c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("社区周榜"), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("意见反馈"), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v("系统设置"), _c('i', {
    staticClass: "cnode-iconfont right"
  }, [_vm._v("")])])])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('v-header', {
    attrs: {
      "title": _vm.title,
      "showMenuButton": false,
      "showBackButton": true,
      "showPostButton": false
    }
  }), _vm._v(" "), (!_vm.showLoading) ? _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "top1"
  }, [_c('img', {
    attrs: {
      "src": _vm.article && _vm.article.author.avatar_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.article && _vm.article.author.loginname)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "time",
    domProps: {
      "textContent": _vm._s(_vm.article && _vm.article.create_at.substring(0, 10))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top2"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.article && _vm.article.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "a_detail"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("\n            " + _vm._s(_vm.article && _vm.article.visit_count) + "\n          ")]), _vm._v(" "), _c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("\n            " + _vm._s(_vm.article && _vm.article.reply_count) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content markdown-body",
    domProps: {
      "innerHTML": _vm._s(_vm.article && _vm.article.content)
    }
  }), _vm._v(" "), (_vm.article.replies && _vm.article.replies.length) ? _c('div', {
    staticClass: "comment"
  }, [_c('ul', _vm._l((_vm.article.replies), function(comment) {
    return _c('li', [_c('v-comment-item', {
      attrs: {
        "comment": comment
      }
    })], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.userInfo.userId) ? _c('div', {
    staticClass: "go_comment"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.go_comment),
      expression: "go_comment"
    }],
    staticClass: "gc_content",
    attrs: {
      "placeholder": "回复支持Markdown语法,请注意标记代码"
    },
    domProps: {
      "value": (_vm.go_comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.go_comment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button_group"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.handleComment
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "cancle"
    },
    on: {
      "click": _vm.cancleComment
    }
  }, [_vm._v("取消")])])]) : _c('div', {
    staticClass: "unlogin"
  }, [_vm._v("\n        您还未"), _c('router-link', {
    attrs: {
      "to": "/login",
      "tag": "span"
    }
  }, [_vm._v("登录")])], 1)]) : _c('v-loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "pagecover",
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), _c('v-header', {
    attrs: {
      "handleMenuButton": _vm.showOrHideMask,
      "show": _vm.show,
      "title": _vm.title
    }
  }), _vm._v(" "), _c('v-side-bar', {
    attrs: {
      "showSideBar": _vm.show,
      "toggleSideBar": _vm.showOrHideMask
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "updateHeaderTitle": _vm.updateHeaderTitle,
      "array": _vm.listArray
    }
  }), _vm._v(" "), _c('v-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }]
  }), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    class: ['vheader', {
      showAnimate: _vm.show
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenuButton),
      expression: "showMenuButton"
    }],
    staticClass: "left",
    on: {
      "click": _vm.showMenu
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackButton),
      expression: "showBackButton"
    }],
    staticClass: "left",
    on: {
      "click": _vm.handleBackButton
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.showMenuButton == false) && (_vm.showBackButton == false)),
      expression: "(showMenuButton==false)&&(showBackButton==false)"
    }],
    staticClass: "left",
    on: {
      "click": _vm.showMenu
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "text",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPostButton),
      expression: "showPostButton"
    }],
    staticClass: "right",
    on: {
      "click": _vm.goPost
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPostButton),
      expression: "!showPostButton"
    }],
    staticClass: "right"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message"
  }, [_c('v-header', {
    attrs: {
      "show_parent": _vm.show,
      "title": _vm.title,
      "showMenuButton": false,
      "showBackButton": true,
      "showPostButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message-detail1"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span', {
    class: {
      active: _vm.active == 'done'
    },
    on: {
      "click": function($event) {
        _vm.toggle('done')
      }
    }
  }, [_vm._v("已读")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.active == 'will'
    },
    on: {
      "click": function($event) {
        _vm.toggle('will')
      }
    }
  }, [_vm._v("未读  " + _vm._s(_vm.message_count ? _vm.message_count : ''))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active === 'done'),
      expression: "active==='done'"
    }],
    staticClass: "bottom markdown-body"
  }, _vm._l((_vm.has_read_message), function(item) {
    return _c('div', {
      staticClass: "message "
    }, [_c('div', {
      staticClass: "user"
    }, [_c('img', {
      staticClass: "head",
      attrs: {
        "src": item.author.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "cl"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.author.loginname))]), _vm._v(" "), (item.type === 'at') ? _c('span', {
      staticClass: "name"
    }, [_vm._v("在回复中@了您")]) : _vm._e(), _vm._v(" "), (item.type === 'reply') ? _c('span', {
      staticClass: "name"
    }, [_vm._v("回复了您的话题")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "reply_content",
      domProps: {
        "innerHTML": _vm._s(item.reply.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "topic-title"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Topic',
          params: {
            id: item.topic.id
          }
        }
      }
    }, [_vm._v("\n              话题：" + _vm._s(item.topic.title) + "\n            ")])], 1)])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active === 'will'),
      expression: "active==='will'"
    }],
    staticClass: "bottom markdown-body"
  }, _vm._l((_vm.hasnot_read_message), function(item) {
    return _c('div', {
      staticClass: "message "
    }, [_c('div', {
      staticClass: "user"
    }, [_c('img', {
      staticClass: "head",
      attrs: {
        "src": item.author.avatar_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "cl"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.author.loginname))]), _vm._v(" "), (item.type === 'at') ? _c('span', {
      staticClass: "name"
    }, [_vm._v("在回复中@了您")]) : _vm._e(), _vm._v(" "), (item.type === 'reply') ? _c('span', {
      staticClass: "name"
    }, [_vm._v("回复了您的话题")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "reply_content",
      domProps: {
        "innerHTML": _vm._s(item.reply.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "topic-title"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Topic',
          params: {
            id: item.topic.id
          }
        }
      }
    }, [_vm._v("\n              话题：" + _vm._s(item.topic.title) + "\n            ")])], 1)])
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('v-header', {
    attrs: {
      "title": _vm.title,
      "showMenuButton": false,
      "showPostButton": false,
      "showBackButton": true
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('h1', [_vm._v("关于项目")]), _vm._v(" "), _c('p', [_vm._v("该项目基于Cnode.js的API，采用VUE全家桶重写的webapp")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', [_vm._v("关于源码")]), _vm._v(" "), _c('p', [_vm._v("请点击"), _c('a', {
    attrs: {
      "href": "https://github.com/fengyinchao/v-cnode.git",
      "title": ""
    }
  }, [_vm._v("这里")]), _vm._v("查看源码")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', [_vm._v("关于反馈")]), _vm._v(" "), _c('p', [_vm._v("请点击"), _c('a', {
    attrs: {
      "href": "https://github.com/fengyinchao/v-cnode/pulls",
      "title": ""
    }
  }, [_vm._v("这里")]), _vm._v("进行反馈")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h1', [_vm._v("关于版本")]), _vm._v(" "), _c('p', [_vm._v("当前版本：V1.0")])])])
}]}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "cube1"
  }), _vm._v(" "), _c('div', {
    staticClass: "cube2"
  })])])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.array), function(item) {
    return _c('li', [_c('v-list-item', {
      attrs: {
        "item": item
      }
    })], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    staticClass: "top",
    attrs: {
      "to": {
        name: 'Topic',
        params: {
          id: _vm.item.id
        }
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "t_left"
  }, [_c('div', {
    staticClass: "tl_top"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.author.avatar_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.item.author.loginname))]), _vm._v(" "), _c('span', {
    staticClass: "create"
  }, [_vm._v(_vm._s(_vm.item.create_at.substring(0, 10)))])])]), _vm._v(" "), _c('div', {
    staticClass: "tl_bottom",
    attrs: {
      "id": "title"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "t_right"
  }, [_c('span', {
    class: {
      good: _vm.item.good
    }
  }, [_vm._v("精华")]), _vm._v(" "), _c('span', {
    class: {
      top1: _vm.item.top
    }
  }, [_vm._v("置顶")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "b_item"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.visit_count))])]), _vm._v(" "), _c('div', {
    staticClass: "b_item"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.reply_count))])]), _vm._v(" "), _c('div', {
    staticClass: "b_item"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.last_reply_at.substring(5, 10)))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('v-header', {
    attrs: {
      "title": _vm.title,
      "showMenuButton": false,
      "showBackButton": true,
      "showPostButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-detail"
  }, [_c('div', {
    staticClass: "login1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accesstoken),
      expression: "accesstoken"
    }],
    attrs: {
      "placeholder": "Access Token"
    },
    domProps: {
      "value": (_vm.accesstoken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accesstoken = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vfooter"
  }, [_c('ul', [_c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/post'
      }
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("发表")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/message'
      }
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("消息")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/me'
      }
    }
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v("我的")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post"
  }, [_c('v-header', {
    attrs: {
      "title": _vm.title,
      "showMenuButton": false,
      "showBackButton": true,
      "showPostButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.title),
      expression: "article.title"
    }],
    staticClass: "title",
    attrs: {
      "required": "",
      "placeholder": "标题...（不少于十个字）"
    },
    domProps: {
      "value": (_vm.article.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.article.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.tab),
      expression: "article.tab"
    }],
    staticClass: "select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.article.tab = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("选择...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "share"
    }
  }, [_vm._v("分享")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ask"
    }
  }, [_vm._v("问答")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "job"
    }
  }, [_vm._v("招聘")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.content),
      expression: "article.content"
    }],
    staticClass: "post_detail",
    attrs: {
      "placeholder": "内容..."
    },
    domProps: {
      "value": (_vm.article.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.article.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "click"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])])], 1)
},staticRenderFns: []}

/***/ })
],[73]);


// WEBPACK FOOTER //
// static/js/app.b79b8d43101901ce8570.js